module.exports = __webpack_public_path__ + "img/sb16.21271fc5.png";